import {
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../../components/SearchBar";
import SwitchToggle from "../../../components/SwitchToggle";
import AddTag from "../../../Modals/addtag";

const ManageTags = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [rows] = useState([
        { id: 1, name: "Selling Fats", active: true },
        { id: 2, name: "New", active: true },
        { id: 3, name: "Premium", active: false },
    ]);

    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => setOpenModal(false);

    return (
        <>
            <div className="main_title">
                <h1>Manage Tags</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -  <button onClick={() => navigate("/manage-groups")}>Manage Groups</button> - Manage Tags
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search Tags..."
                        />
                    </div>

                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
                            <AddIcon /> Add Tag
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>Tag Name</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows.map((row, index) => (
                                <TableRow hover key={row.id}>

                                    {/* Sr No */}
                                    <TableCell>{index + 1}</TableCell>

                                    {/* Group Name */}
                                    <TableCell>
                                        <b>{row.name}</b>
                                    </TableCell>

                                    {/* Status Toggle */}
                                    <TableCell>
                                        <SwitchToggle checked={row.active} />
                                    </TableCell>

                                    {/* Actions */}
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton onClick={() => setOpenModal(true)}>
                                                <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                            </IconButton>

                                        </div>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <AddTag
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default ManageTags;
